
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Card,
  CardContent,
  Grid,
  Paper,
  Tab,
  Tabs,
} from '@material-ui/core';
import { TabContainer } from '../../custom-tab-container/custom-tab-container';
import FormFieldsIntakeAssessRiskFactorsIntake from './tabs/tab-risk-factors-intake';
import FormFieldsIntakeAssessSoclDtrntFctrsOrntnAsmnt from './tabs/tab-social-determinant-factors-orientation-assessment';
import FormFieldsIntakeAssessWlnsPrgmPlng from './tabs/tab-wellness-program-planning';
class FormFieldsClientsTabsTabIntakeAssessment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headerTabs: 0,
    };
  }
  handleChangeClientDetailsHeader = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }
  render () {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.headerTabs}
                    onChange={this.handleChangeClientDetailsHeader}
                    indicatorColor="primary"
                    textColor="primary"                    
                    variant="scrollable"
                                                                            // scrollButtons="auto"
                    scrollButtons="on"
                  >
                    <Tab label="Risk Factors" />
                    <Tab label="Social Determinant Factors" />
                    <Tab label="Wellness" />
                  </Tabs>
                </AppBar>

                {this.state.headerTabs === 0 && <TabContainer>
                  <FormFieldsIntakeAssessRiskFactorsIntake
                    locked={this.props.locked}
                    initialValues={this.props.clientMode === 0 ? this.state.clientEntry : this.props.clientEntry}
                  />
                </TabContainer>} 

                {this.state.headerTabs === 1 && <TabContainer>
                  <FormFieldsIntakeAssessSoclDtrntFctrsOrntnAsmnt 
                    locked={this.props.locked}
                    initialValues={this.props.clientMode === 0 ? this.state.clientEntry : this.props.clientEntry}
                  />
                </TabContainer>}

                {this.props.form !== 'ReferralEditForm' ? 
                <>
                  {this.state.headerTabs === 2 && <TabContainer>
                      <FormFieldsIntakeAssessWlnsPrgmPlng 
                        locked={this.props.locked}
                        initialValues={this.props.clientMode === 0 ? this.state.clientEntry : this.props.clientEntry}
                        programSelected={this.props.programSelected}
                      />
                    </TabContainer>}
                </>
                : null }

              </Grid>

            </CardContent>
          </Card>
        </Paper>
      </div>
    )
  }
}
FormFieldsClientsTabsTabIntakeAssessment.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string
}
export default FormFieldsClientsTabsTabIntakeAssessment